import { Switch } from '@nexelem/components';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type FormSwitchProps = {
  name: string;
  className?: string;
  leftContentText?: string;
  rightContentText?: string;
  label?: string;
};

export const FormSwitch = ({ name, leftContentText, rightContentText, className, label }: FormSwitchProps) => {
  const { t } = useTranslation('common');
  const { field } = useController({ name });

  return (
    <Switch
      checked={field.value}
      className={className}
      label={label}
      leftContentText={leftContentText || t('common.yes')}
      rightContentText={rightContentText || t('common.no')}
      onClick={field.onChange}
    />
  );
};
